import React, { useEffect, useState } from 'react'
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { View, Image, ActivityIndicator } from 'react-native';
import { isMobile } from 'react-device-detect';

import { Icon, Avatar } from 'react-native-elements';
import { Text, TouchableOpacity } from '../globalComponents/NativeOverrides';
import { useDispatch, useSelector } from 'react-redux';

//import internal components
import Colors from '../constants/Colorsv2';

//import types
import AppModeToggle from './AppModeToggle';
import AccountModal from'../screens/modalScreens/AccountModal';
import { getPlayerBalanceByPlayerId, getPlayerSettingsByPlayerId, player_getCodeRequestByPlayerId } from '../store/actionsv1/player';
import { auth_changeMarketType, auth_clearNotification, auth_getMe, auth_getNotificationById, auth_logout, auth_setNotification } from '../store/actionsv1/auth';
import { CodeRequestProps, PlayerBalanceProps, PlayerNotificationProps, PromoProps, PublicPlayerProps } from '../store/types/auth_svc';
import { util_updateHeaderHeight } from '../store/actionsv1/utils';
import { V1_FULFILL_ALERT_CLOSED, V1_SHOW_AUTHENTICATE, V1_SHOW_PROFILE, V1_SHOW_WALLET, V1_UPDATE_BOTTOM_TAB_HEIGHT, V1_UPDATE_INITIAL_URL, V1_UPDATE_MARKET_TYPE, V1_UPDATE_WALLET_VISIBILE } from '../store/actionsv1/types';
import { useLinkTo } from '@react-navigation/native';
import PWAPrompt from './PWAPrompt';
import NotificationPrompt from './NotificationPrompt';
import ActiveChallenger from './ActiveChallenger';
import { OrderProps } from '../store/types/mk_svc';
import { market_getOrdersByPlayerId } from '../store/actionsv1/markets';
import moment from 'moment';
import { useBottomTabBarHeight } from '@react-navigation/bottom-tabs';

type HeaderCardProps = {
    navigation: any;
    backVisible:boolean;
}

function AppHeader({navigation, backVisible}: HeaderCardProps){
    const [ desktop_message_visible, setDesktopMessageVisible ] = useState(false);
    const [ getPlayerLoading, setGetPlayerLoading ] = useState(false);
    const [ accountVisible, setAccountVisible ] = useState(false);
    const dispatch = useDispatch();
    const linkTo = useLinkTo();
    //Set up Selectors from redux
    const isAuthenticated:boolean = useSelector((state:any) => state.auth.isAuthenticated, (left, right) => left == right);
    const fulfill_alert_closed:boolean = useSelector((state:any) => state.util.fulfill_alert_closed, (left, right) => left == right);
    const initial_url:string | undefined = useSelector((state:any) => state.util.initial_url, (left, right) => left == right)
    const no_help:boolean = useSelector((state:any) => state.auth.no_help, (left, right) => left == right);
    const app_size:{ width:number } = useSelector((state:any) => state.util.app_size, (left, right) => left.width == right.width)
    const challenger:PublicPlayerProps|undefined = useSelector((state:any) => state.market.challenger, (left, right) => left?.player_id == right?.player_id);
    const notification:PlayerNotificationProps | undefined = useSelector((state:any) => state.auth.notification, (left, right) => left?.player_notification_id == right?.player_notification_id)
    const notification_id:string | undefined = useSelector((state:any) => state.auth.notification_id, (left, right) => left == right)
    const market_type:string = useSelector((state:any) => state.auth.market_type, (left, right) => left === right)
    const player:PublicPlayerProps | undefined = useSelector((state:any) => state.player.player, (left, right) => {
        if(left?.player_id != right?.player_id){ return false }
        if(left?.updated != right?.updated){ return false }
        return true
    })
    const bottom_tab_height = useBottomTabBarHeight()

    //Order details
    const orders_state:{updated:number, orders:OrderProps[]} = useSelector((state:any) => state.player.orders, (left, right) => left.updated == right.updated)
    const orders = orders_state.orders.filter(o => o.market_type === market_type && o.status == 'approved' && moment(o.expire_datetime).diff(moment(), 'hours') < 1);

    const last_route: { key :string, params:any } | undefined = useSelector((state:any) => state.util.last_route, (left, right) => left?.key == right?.key);
    const player_balance:PlayerBalanceProps | undefined = useSelector((state:any) => state.player.player_balance, (left, right) => {
        if(left?.player_id != right?.player_id){ return false }
        if(left?.free_market_balance !== right?.free_market_balance){ return false }
        if(left?.balance !== right?.balance){ return false }
        if(left?.promo_balance != right?.promo_balance){ return false }
        return true
    })
    const header_height:number = useSelector((state:any) => state.util.header_height, (left, right) => left === right)
    const audio_height:number = useSelector((state:any) => state.util.audio_height, (left, right) => left === right)
    const player_notification_count:number = useSelector((state:any) => state.player.player_notification_count, (left, right) => left == right)
    const code_request:CodeRequestProps|undefined = useSelector((state:any) => state.player.code_request, (left, right) => {
        if(left?.code_request_id != right?.code_request_id){ return false }
        if(left?.status != right?.status){ return false }
        return true
    })
    const viewing_referrer:PublicPlayerProps|undefined = useSelector((state:any) => state.player.viewing_referrer, (left, right) => left?.player_id == right?.player_id);
    const promo:PromoProps|undefined = useSelector((state:any) => state.player.viewing_promo, (left, right) => left?.promo_id == right?.promo_id)
    
    useEffect(() => {
        dispatch({ type: V1_UPDATE_BOTTOM_TAB_HEIGHT, bottom_tab_height: bottom_tab_height })
    },[bottom_tab_height])
    
    useEffect(() => {
        if(!market_type){ dispatch({ type:V1_UPDATE_MARKET_TYPE, market_type: 'FOR_MONEY' }) }
        if(isAuthenticated && !player){ dispatch(auth_getMe()) }
        //if(!market_type){ dispatch(auth_changeMarketType()) }
        if(!isAuthenticated || !player){ return }
        if(player?.player_id && player_balance){ return }
        getPlayerDetailsByPlayerIdFromServer(player.player_id)
    },[isAuthenticated, player?.player_id])
    
    useEffect(() => {

        //If not authenticated - don't do anything!
        if(!isAuthenticated){ return }
        if(!notification_id){
            if(!initial_url || !player?.phone_verified){ return }
            linkTo(initial_url)
            dispatch({ type: V1_UPDATE_INITIAL_URL, initial_url:undefined })
            return
        }
        if(!notification){ 
            dispatch(auth_getNotificationById(notification_id)) 
        } else {
            handleNotification(notification)
            dispatch(auth_setNotification())
            dispatch(auth_clearNotification())
        }
    },[isAuthenticated, notification_id, notification])

    
    const goBack = () => {
        if(last_route) {
            navigation.navigate({ key: last_route.key, params: last_route.params }) 
        }
        return navigation.goBack()
    }

    const handleNotification = (player_notification: PlayerNotificationProps) => {
        const { options } = player_notification
        //if(route.params.action && route.params.action !== 'nav' && route.params.action !== ''){ return console.log('Need to do an action on this one!') }
        navigation.navigate(options.data.pageStack, { screen: options.data.page, initial: false, params: options.data.pageParams })
        //if(options.data.pageStack !== 'HomeStack'){
        //}
    }


    const handleAddFunds = () => {
        if(!player?.vouched_status){ return }
        if(player.vouched_status !== 'verified'){
            return dispatch({ type: V1_SHOW_PROFILE, show_profile: { visible: true, profile_attribute: 'vouch' } })
            //return navigation.navigate('AuthStack', { screen:'VouchStatus', params: {} })
        }
        return dispatch({ type: V1_SHOW_WALLET, show_wallet: { visible: true } })
        //dispatch({ type: V1_UPDATE_WALLET_VISIBILE, visible:true })
        //return navigation.navigate('HomeStack', { screen: 'ACH', initial:false })
    }

    const handleChangeMarketType = async(market_type:string) => {
        await dispatch(auth_changeMarketType())
    }

    const handleNav = (screen:string) => {
        if(isAuthenticated && !player){
            dispatch(auth_logout())
        }
        return navigation.navigate('AuthStack', { screen })
    }

    const getPlayerDetailsByPlayerIdFromServer = async(player_id:string) => {
        if(getPlayerLoading){ return }
        setGetPlayerLoading(true)
        await dispatch(market_getOrdersByPlayerId(player_id, 0, true, 'inprogress'))
        await dispatch(getPlayerBalanceByPlayerId(player_id))
        await dispatch(getPlayerSettingsByPlayerId(player_id))
        await dispatch(player_getCodeRequestByPlayerId(player_id))
        setGetPlayerLoading(false)
    }    

    const insets = useSafeAreaInsets();

    const getBackgroundColor = () => {
        if(!isAuthenticated){ return Colors.brand.electric }
        if(market_type == 'FREE'){ return Colors.brand.cyan }
        if(player?.type == 'premium'){ return Colors.brand.cobalt }
        return Colors.brand.electric
    }

    return (
        <View style={{paddingTop: insets.top, backgroundColor: getBackgroundColor(), marginBottom:audio_height }} onLayout={(event) => {
            const { height } = event.nativeEvent.layout;
            if(height == 0){ return }
            return dispatch(util_updateHeaderHeight(height))
          }}>
            {!isMobile && desktop_message_visible ?
             <View style={{ flexDirection:'row', padding:4, backgroundColor:Colors.utility.warning, alignItems:'center' }}>
                <View style={{ padding:10 }}>
                    <Icon  name='smartphone' size={30} color={Colors.shades.white} type='feather' />
                </View>
                <View style={{ flex:1, padding:10, borderLeftWidth:1, borderLeftColor:Colors.shades.shade100 }}>
                    <Text style={{ flex:1 }} size={14} color={Colors.shades.white} textAlign='left' weight='bold'>BettorEdge is only designed for a mobile experience.  Desktop mode is not fully supported and you may experience issues.  Please utilize the mobile web app for best experience.</Text>
                </View>
                <TouchableOpacity style={{ padding:10, paddingLeft:20 }} onPress={() => setDesktopMessageVisible(false)}>
                    <Icon name='x' type='feather' size={24} color={Colors.shades.white} />
                </TouchableOpacity>
            </View>
            :<></>}
            <View style={{ flexDirection:'row', alignItems:'center' }}>
                <View>
                    {backVisible?
                    <TouchableOpacity style={{padding:17, flexDirection:'row', alignItems:'center'}} onPress={() => goBack()}> 
                        <View style={{ marginRight:12, height:25, justifyContent:'center', alignItems:'center' }}>
                            <Icon name='chevron-left' type='feather' size={16} color={Colors.shades.white} />
                        </View>
                        <View style={{height:25, justifyContent:'center', alignItems:'center'}}>
                            <Text weight='regular' color={Colors.shades.white} size={14}>Back</Text>
                        </View>
                    </TouchableOpacity>
                    :
                    <View style={{ flexDirection:'row', alignItems:'center' }}>
                        <TouchableOpacity style={{padding:17}} onPress={() => navigation.navigate('EventStack', { screen:'Markets' })}>
                            <Image 
                                source={{ uri: player?.type == 'premium' ? require('../assets/images/prem_nav_logo.png') : require('../assets/images/beNavLogo.png') }} 
                                resizeMode='center' 
                                style={{height:25, width:25}}/>
                        </TouchableOpacity>
                        <PWAPrompt />
                        <NotificationPrompt />
                    </View>
                    }
                </View>
                <View style={{ flex:1, alignItems:'flex-end' }}>
                {isAuthenticated && player ?
                <View style={{flex:1, flexDirection:'row', alignItems:'center'}}>
                    { player_balance && market_type ?
                        <AppModeToggle 
                            market_type={market_type} 
                            balance={Math.floor(player_balance.balance * 100) / 100} 
                            promo_balance={Math.floor(player_balance.promo_balance * 100) / 100} 
                            free_market_balance={Math.floor(player_balance.free_market_balance * 100) / 100} 
                            onAppModeChange={(market_type:'FREE'|'FOR_MONEY') => handleChangeMarketType(market_type)} 
                            onBalancePress={handleAddFunds}
                            />
                        :
                        <ActivityIndicator size='small' color={Colors.shades.white} />
                        }
                        <View>
                            <Image source={require('../assets/images/pipe-faded.png')} resizeMode='contain' style={{height:25, width:10}}/>
                        </View>
                        <TouchableOpacity style={{marginLeft:15}} onPress={() => navigation.navigate('DiscoverStack', { screen:'Search', initial:false, params: {} })}>
                            <Icon name='search' type='feather' color={Colors.shades.white} size={18} />
                        </TouchableOpacity>
                        <TouchableOpacity style={{marginLeft:20}} onPress={() => navigation.navigate('HomeStack', { screen:'Notification', initial:false, params:{} })}>
                            <Icon name='bell' type='feather' color={Colors.shades.white} size={18} />
                            {player_notification_count > 0 ?
                            <View style={{position:'absolute', borderRadius:100, backgroundColor:Colors.utility.error, top:-8, right:-8, padding:2}}>
                                <Text size={10} color={Colors.shades.white} weight='regular' textAlign='center'>{player_notification_count}</Text>
                            </View>
                            :<></>}
                        </TouchableOpacity>
                        <TouchableOpacity style={{marginLeft:16, marginRight:12}} onPress={() => setAccountVisible(!accountVisible)}>
                            <Avatar size='small' rounded title={player.first_name[0]} source ={player.profile_pic?{ uri: player.profile_pic }:require('../assets/images/default-avatar.png')} />
                        </TouchableOpacity>
                        <AccountModal 
                            navigation={navigation} 
                            isVisible={accountVisible} 
                            onChangePreference={(market_type) => dispatch(handleChangeMarketType(market_type))} 
                            player={player} 
                            width={app_size.width}
                            no_help={no_help}
                            backgroundColor={getBackgroundColor()}
                            player_balance={player_balance} 
                            market_type={market_type} 
                            headerHeight={header_height} 
                            onSignOut={() => dispatch(auth_logout())}
                            closeModal={() => setAccountVisible(false)}/>
                        </View> 
                    : !getPlayerLoading && !isAuthenticated ?
                        <View style={{flexDirection:'row', alignItems:'center', justifyContent:'center', paddingRight:10}}>
                            
                            <TouchableOpacity style={{ padding:10, backgroundColor:Colors.utility.success, borderRadius:23 }} onPress={() => navigation.navigate('AuthStack', { screen:'Authenticate' })}>
                                <Text color={Colors.shades.white} weight='bold' textAlign='center' size={14}>Get Started</Text>
                            </TouchableOpacity>
                        </View>
                    : 
                    <ActivityIndicator style={{marginRight:12}} color={Colors.shades.white} size='small' />
                    }
                </View>
            </View>
            {orders.length > 0 && !fulfill_alert_closed ?
            <View style={{ padding:5, backgroundColor:Colors.utility.warning}}>
                <View style={{ flexDirection:'row', alignItems:'center', padding:5 }}>
                    <View style={{ flex:1, marginRight:10 }}>
                        <Text size={16} color={Colors.brand.midnight} weight='bold'>You have unfulfilled orders</Text>
                        <Text style={{ marginTop:3 }} size={14} color={Colors.brand.midnight}>Go to your dashboard to get them fulfilled!</Text>
                    </View>
                    <View style={{ flexDirection:'row' }}>
                        <TouchableOpacity style={{ padding:10, marginRight:5, borderRadius:4, backgroundColor:Colors.shades.shade100 }}>
                            <Icon name='alert-circle' type='feather' size={16} color={Colors.utility.warning} />
                        </TouchableOpacity>
                        <TouchableOpacity style={{ padding:10, marginRight:5, borderRadius:4, backgroundColor:Colors.brand.midnight }}
                            onPress={() => {
                                dispatch({ type: V1_FULFILL_ALERT_CLOSED })
                                navigation.navigate('HomeStack', { screen: 'Dashboard' })
                            }}
                        >
                            <Text size={14} color={Colors.shades.white} textAlign='center'>Review</Text>
                        </TouchableOpacity>
                    </View>
                </View> 
            </View>
            :<></>}
            {!isAuthenticated && viewing_referrer ?
            <TouchableOpacity style={{flexDirection:'row', alignItems:'center', padding:5, backgroundColor:Colors.incentive.gold }} onPress={() => dispatch({ type:V1_SHOW_AUTHENTICATE, show_authenticate:{ visible:true } })}>
                <View nativeID='verify_image' style={{ padding:5 }}>
                    <Image
                        source={{ uri: viewing_referrer?.profile_pic }}
                        style={{ height:40, width:40, borderRadius:4 }}
                        resizeMode='cover'
                    />
                </View>
                <View style={{ flex:1, marginLeft:5, marginRight:5 }}>
                    <Text size={16} color={Colors.shades.white} weight='bold'>Claim your gift from @{viewing_referrer?.username}</Text>
                    <Text style={{ marginTop:3 }} size={14} color={Colors.shades.white}>Sign Up and Verify your account to claim your gift</Text>
                </View>
                <Icon style={{ padding:5 }} name='chevron-right' size={18} color={Colors.brand.midnight}/>
            </TouchableOpacity>
            :<></>}
            {isAuthenticated && player && player.vouched_status !== 'verified' ?
            <TouchableOpacity nativeID='verify-trigger' style={{flexDirection:'row', alignItems:'center', padding:5, backgroundColor:Colors.accents.accent100}} onPress={() => dispatch({ type:V1_SHOW_PROFILE, show_profile: { visible:true, profile_attribute:'vouch' } })}>
                <View nativeID='verify_image' style={{ padding:5 }}>
                    <Image
                        source={{ uri: 'https://res.cloudinary.com/hoabts6mc/image/upload/v1698934656/verify_splskz.webp' }}
                        style={{ height:40, width:40, borderRadius:4 }}
                        resizeMode='cover'
                    />
                </View>
                <View style={{ flex:1, marginLeft:5, marginRight:5 }}>
                    <Text size={16} color={Colors.brand.midnight} weight='bold'>Your account is not verified</Text>
                    {code_request?.status == 'verified' ?
                    <Text style={{ marginTop:3 }} size={14} color={Colors.brand.midnight}>Verify and redeem a gift from {viewing_referrer?.username ?? 'BettorEdge'}</Text>
                    :
                    <Text style={{ marginTop:3 }} size={14} color={Colors.brand.midnight}>Verify now to use real money!  Press here.</Text>
                    }
                </View>
                <Icon style={{ padding:5 }} name='chevron-right' size={18} color={Colors.brand.midnight}/>
            </TouchableOpacity>
            :<></>}
           {promo && isAuthenticated && player && player.vouched_status === 'verified' && code_request?.status == 'verified'?
           <TouchableOpacity nativeID='verify-trigger' style={{flexDirection:'row', alignItems:'center', padding:5, backgroundColor:Colors.incentive.gold}} onPress={() => dispatch({ type:V1_SHOW_PROFILE, show_profile: { visible:true, profile_attribute: 'vouch' } })}>
                <View nativeID='referrer_image' style={{ padding:5 }}>
                    <Image
                        source={{ uri: viewing_referrer?.profile_pic && viewing_referrer.profile_pic != '' ? viewing_referrer.profile_pic : 'https://res.cloudinary.com/hoabts6mc/image/upload/v1665754369/redeem_sweepstakes_glp6f2.webp' }}
                        style={{ height:40, width:40, borderRadius:4 }}
                        resizeMode='cover'
                    />
                </View>
                <View style={{ flex:1, marginLeft:5, marginRight:5 }}>
                    <Text size={16} color={Colors.shades.white} weight='bold'>Gift from {viewing_referrer?.username ?? 'BettorEdge'}</Text>
                    <Text style={{ marginTop:3 }} size={14} color={Colors.shades.white}>Press here to claim now!</Text>
                </View>
                <Icon style={{ padding:5 }} name='chevron-right' size={18} color={Colors.shades.white}/>
            </TouchableOpacity>
           :<></>}
            <ActiveChallenger
                navigation={navigation}
                challenger={challenger}
            />
        </View>
    )
}

export default AppHeader